export enum ConsolidatedDataSyncStatus {
    SYNCING_FROM_CLOUD = "SYNCING_FROM_CLOUD",
    SYNCING_TO_CLOUD = "SYNCING_TO_CLOUD",
    NOTHING_TO_SYNC = "NOTHING_TO_SYNC"
}